export default 'activityChartPage';
